import React, { useState } from 'react';
import EditAccountLayout from '../../components/EditAccountLayout.jsx';
import './edit-account.css';
import { TbListDetails } from "react-icons/tb";
import { Form, Col , Row, Button} from 'react-bootstrap';
import Select from 'react-select';
import { FaEdit } from "react-icons/fa";

export default function EditAccount() {
  // State for role selection
  const [account, setAccount] = useState(null);

  // Options for role selection
  const accountOptions = [
    { value: 'purchase account', label: 'Purchase Account' },
    { value: 'sales account', label: 'Sales Account' },
  ];

  // CustomSelect component
  const CustomSelect = ({ options, value, onChange, placeholder }) => {
    return (
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        classNamePrefix="custom-select"
      />
    );
  };

  return (
    <>
      <EditAccountLayout>
        <h1 className='edit-account-title'><TbListDetails />Account Details</h1>
        <hr/>
        <div className='edit-account-container'>
          <Row>
            <Form.Group as={Col} xs={12} md={6} controlId="formGridUserName">
              <Form.Label>Account Name <span className='required'>*</span>:</Form.Label>
              <Form.Control type="text" name="account-name" required placeholder="Enter Your Account Name" className="form-control" />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="formGridRole">
              <Form.Label>Account Category <span className='required'>*</span>:</Form.Label>
              <CustomSelect
                options={accountOptions}
                value={account}
                onChange={setAccount}
                placeholder="--Select--"
              />
            </Form.Group>
          </Row>
          <div className='edit-button-container'>
            <Button className='btn btn-primary edit-account-button'><FaEdit  className="button-icon" />Update</Button>
          </div>
        </div>
      </EditAccountLayout>
    </>
  );
}
